<br><br>
<app-gestiones-header-preca [buttonselected]=3 [participante]="participante" [gestionSeleccionada]="gestionSeleccionada" (selecttab)="selectedtab($event)" (selectParticipante)="selectedparticipante($event)"></app-gestiones-header-preca>
<div class="container-fluid">
    <div class="row table-full">
        <div class="table-data">
            <div class="cabecera-gris">
                <h1>INFORME DE BURO INTERNO - BANTRAB GT-</h1>
            </div>
            <div class="cabecera-outline">
                <h1>INFORMACION DEL CLIENTE</h1>
            </div>
            <div *ngIf="datacliente.cliente!=null" class="table4" style="width: 60%;margin: 0 auto 0 auto;">
                <table class="table table-borderless">
                  <tbody>
                    <tr>
                      <th>Código Cliente</th>
                      <th>Nombre Completo</th>
                      <th>¿Actualizado?</th>
                      <th>Nombre Patrono</th>

                    </tr>
                    <tr>
                      <td>{{datacliente.cliente.codigoClienteBantrab}}</td>
                      <td>{{datacliente.cliente.nombreCompleto}}</td>
                      <td>{{ datacliente.cliente.existeclienteActualizado|ReplaceText: 'No' }}</td>
                      <td>{{gestionSeleccionada.participante[this.participante].datosIndice.patrono.nombrePatrono}}</td>
                    </tr>
                  </tbody>
                </table>
            </div>
            <div class="cabecera-outline" style="width: 90%;">
                <h1>INFORMACIÓN DE CRÉDITOS</h1>
            </div>
            <div class="table4">
                <table class="table table-borderless">
                  <tbody>
                    <tr>
                      <th>No. Crédito</th>
                      <th>Código Cliente</th>
                      <th>Relación Crédito</th>
                      <th>Descripción Crédito</th>
                      <th>DPI titular</th>
                      <th>Estado</th>
                      <th>Capital Original</th>
                      <th>Saldo</th>
                      <th>Cuota</th>
                      <th>Descuento Codeudor</th>
                      <th>Fecha Concesión</th>
                      <th>Fecha Vencimiento</th>
                      <th>Monto Pagado Principal</th>
                      <th>Cuotas Pagadas</th>
                      <th>Cuotas Por Pagar</th>
                    </tr>
                    <tr *ngFor="let element of gestionSeleccionada.participante[this.participante].buroInterno.creditos">
                      <td>{{element.noCredito}}</td>
                      <td>{{element.codigoCliente}}</td>
                      <td>{{element.directoIndirecto}}</td>
                      <td>{{element.descripcion}}</td>
                      <td>{{element.dpi}}</td>
                      <td>{{element.abrevEstado}}</td>
                      <td>{{element.capitalOriginal| currency:"Q "}}</td>
                      <td>{{element.saldo| currency:"Q "}}</td>
                      <td>{{element.cuota| currency:"Q "}}</td>
                      <td>{{element.descuentoCodeudor}}</td>
                      <td>{{element.fConsecion}}</td>
                      <td>{{element.fVencimiento}}</td>
                      <td>{{element.montoPagadoPrincipal| currency:"Q "}}</td>
                      <td>{{element.cuotasPagadas}}</td>
                      <td>{{element.cPorPagar}}</td>
                    </tr>
                  </tbody>
                </table>
            </div>
            <div class="cabecera-outline" style="width: 90%;">
                <h1>INFORMACIÓN DE TARJETAS</h1>
            </div>
            <p *ngIf="gestionSeleccionada.participante[this.participante].buroInterno.tarjetas[0].noTarjeta==''">Cliente no posee tarjetas</p>
            <div *ngIf="gestionSeleccionada.participante[this.participante].buroInterno.tarjetas[0].noTarjeta!=''" class="table4">
                <table class="table table-borderless">
                  <tbody>
                    <tr>
                      <th>No. Tarjeta</th>
                      <th>Tipo Tarjeta</th>
                      <th>Fecha Concesión</th>
                      <th>Fecha Activación</th>
                      <th>Saldo</th>
                      <th>Estado</th>
                      <th>Días de Mora</th>
                      <th>Pago Mínimo</th>
                      <th>Limite Crédito</th>
                      <th>Extrafinanciamiento</th>
                    </tr>
                    <tr *ngFor="let element of gestionSeleccionada.participante[this.participante].buroInterno.tarjetas">
                      <td>**** **** **** {{element.noTarjeta.substring(element.noTarjeta.length-4)}}</td>
                      <td>{{element.tipoTarjeta}}</td>
                      <td>{{element.fechaConsesion}}</td>
                      <td>{{element.fechaActivacion}}</td>
                      <td>{{element.saldo| currency:"Q "}}</td>
                      <td>{{element.estado}}</td>
                      <td>{{element.diasMora}}</td>
                      <td>{{element.pagoMinimo| currency:"Q "}}</td>
                      <td>{{element.limiteCredito| currency:"Q "}}</td>
                      <td>{{element.extrafinanciamiento| currency:"Q "}}</td>
                    </tr>
                  </tbody>
                </table>
            </div>
            <div class="cabecera-outline">
                <h1>LISTAS DE SEGUIMIENTOS</h1>
            </div>
            <p *ngIf="gestionSeleccionada.participante[this.participante].listaSeguimiento.length==0||gestionSeleccionada.participante[this.participante].listaSeguimiento[0].mensajeConsultaBuroInternoBantrab=='Cliente no encontrado en lista'">No hay información en los datos de las Listas de Seguimiento.</p>
            <div class="table4" *ngIf="gestionSeleccionada.participante[this.participante].listaSeguimiento.length>0 && gestionSeleccionada.participante[this.participante].listaSeguimiento[0].mensajeConsultaBuroInternoBantrab!=='Cliente no encontrado en lista'">
              <table class="table table-borderless">
                <tbody>
                  <tr>
                    <th>Código Persona</th>
                    <th>Estado</th>
                    <th>Nombre Cliente</th>
                    <th>Numero Extensión</th>
                    <th>Numero Lista</th>
                    <th>Numero Teléfono</th>
                    <th>Restringe Lista</th>
                  </tr>
                  <tr *ngFor="let element of gestionSeleccionada.participante[this.participante].listaSeguimiento">
                    <td>{{element.codigoPersona}}</td>
                    <td>{{element.estadoLista}}</td>
                    <td>{{element.nombreCliente}}</td>
                    <td>{{element.numeroExtension}}</td>
                    <td>{{element.numeroLista}}</td>
                    <td>{{element.numeroTelefono}}</td>
                    <td>{{element.restringeLista}}</td>
                  </tr>
                </tbody>
              </table>
          </div>
        </div>
    </div>
</div>
